/**
 * @desc PDA扫描外箱条码/托盘上架
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InMasterBoxShelvesRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/plateShelves`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
